import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import ReactExport from "@ibrahimrahmani/react-export-excel";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";

import CallMadeIcon from "@mui/icons-material/CallMade";

import FolderSpecialIcon from "@mui/icons-material/FolderSpecialOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";

import SimpleTable from "../../components/SimpleTable";
import AgregarOrganismoModal from "./AgregarOrganismoModal";
import { setError, setSuccess } from "../../reducers/appSlice";
import TransferirOrganismoModal from "./TransferirOrganismoModal";

const headers = [
  {
    id: "organismoId",
    label: "ID",
    // align: "right",
    // sortable: true,
  },
  {
    id: "organismoBaseId",
    label: "BASE",
    // align: "left",
    // sortable: true,
  },
  {
    id: "descripcion",
    label: "Descripción",
    // align: "right",
    // sortable: true,
  },
  {
    id: "mesaEntrada",
    label: "Mesa de entrada",
    // align: "right",
    // sortable: true,
  },
  {
    id: "acciones",
    label: "Acciones",
    align: "center",
    width: "200",
  },
];

const ListadoOrganismos = ({
  grupoId,
  organismos,
  agregar,
  marcarMesaEntrada,
  transferir,
}) => {
  const dispatch = useDispatch();
  const [openModalAgregar, setOpenModalAgregar] = useState(false);
  const [marcandoEntradaId, setMarcandoEntradaId] = useState(null);
  const [openModalTransferir, setOpenModalTransferir] = useState(false);
  const [organismoTransferir, setOrganismoTransferir] = useState(null);
  const [filteredOrganismos, setFilteredOrganismos] = useState(organismos);
  const [filter, setFilter] = useState("");

  const handleOpenModalAgregar = () => setOpenModalAgregar(true);
  const handleCloseModalAgregar = () => setOpenModalAgregar(false);
  const handleCloseModalTransferir = () => {
    setOrganismoTransferir(null);
    setOpenModalTransferir(false);
  };

  const handleMarcar = async (organismo, mesaEntrada) => {
    try {
      setMarcandoEntradaId(organismo.organismoId);
      await marcarMesaEntrada({
        organismo: organismo.organismoId,
        grupo: grupoId,
        mesaEntrada: mesaEntrada,
      });
      dispatch(setSuccess("Mesa de entrada actualizada"));
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      setMarcandoEntradaId(null);
    }
  };

  const handleFilter = (event) => {
    setFilter(event.target.value);
  };

  const filterData = (element) => {
    return (
      element.descripcion?.toLowerCase().includes(filter.toLowerCase()) ||
      (element.organismoId ?? '').toString().includes(filter) ||
      (element.organismoBaseId ?? '').toString().includes(filter)
    );
  };

  useEffect(() => {
    if (!organismoTransferir) return;

    setOpenModalTransferir(true);
  }, [organismoTransferir]);

  useEffect(() => {
    if (filter) {
      setFilteredOrganismos(
        organismos.filter((organismo) => filterData(organismo))
      );
    } else {
      setFilteredOrganismos(organismos);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  return (
    <Paper sx={{ px: 2, py: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          // flexDirection: "row",
          flexDirection: "row-reverse",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
          pt: 1,
        }}
      >
        {/* <Stack direction="row" spacing={1}>
          <ExcelFile
            filename="Reporte organismos"
            element={
              <IconButton
                disabled={organismos.length == 0}
                title="Exportar"
                size="small"
              >
                <DownloadIcon />
              </IconButton>
            }
          >
            <ExcelSheet data={organismos} name="Organismos">
              <ExcelColumn label="Códgio" value="codigo" />
              <ExcelColumn label="Descripcion" value="descripcion" />
              <ExcelColumn label="Padre" value="padre" />
              <ExcelColumn label="Acceso al sistema" value="accesoSistema" />
            </ExcelSheet>
          </ExcelFile>
        </Stack> */}
        <Box>
          <Button
            variant="verde"
            sx={{ m: 1 }}
            endIcon={<AddIcon />}
            onClick={handleOpenModalAgregar}
          >
            Nuevo
          </Button>
          <IconButton
            color="primary"
            title="Nuevo"
            size="medium"
            sx={{
              color: "#fff",
              backgroundColor: "#799F4F",
              "&:hover": { color: "#fff", backgroundColor: "#546f37" },
              display: { xs: "inherit", md: "none" },
            }}
            onClick={handleOpenModalAgregar}
          >
            <AddIcon />
          </IconButton>
        </Box>
        <TextField
          id="filtro"
          label="Buscar"
          variant="outlined"
          size="small"
          value={filter}
          onChange={handleFilter}
        />
      </Box>
      <Box sx={{ border: "1px solid #dee2e6" }}>
        <SimpleTable
          headers={headers}
          rows={filteredOrganismos.map((organismo) => ({
            ...organismo,
            mesaEntrada: organismo.mesaEntrada === "S" ? "Si" : "No",
            acciones: (
              <>
                {organismo.mesaEntrada === "S" ? (
                  <IconButton
                    title="Desmarcar mesa de entrada"
                    size="small"
                    onClick={() => handleMarcar(organismo, "N")}
                    disabled={organismo.organismoId === marcandoEntradaId}
                  >
                    <FolderSpecialIcon fontSize="small" />
                  </IconButton>
                ) : (
                  <IconButton
                    title="Marcar mesa de entrada"
                    size="small"
                    onClick={() => handleMarcar(organismo, "S")}
                    disabled={organismo.organismoId === marcandoEntradaId}
                  >
                    <FolderOutlinedIcon fontSize="small" />
                  </IconButton>
                )}
                <IconButton
                  title="Transferir"
                  size="small"
                  onClick={() => setOrganismoTransferir(organismo)}
                >
                  <CallMadeIcon fontSize="small" />
                </IconButton>{" "}
              </>
            ),
          }))}
        />
      </Box>
      <AgregarOrganismoModal
        open={openModalAgregar}
        handleClose={handleCloseModalAgregar}
        grupo={grupoId}
        agregar={agregar}
      />
      <TransferirOrganismoModal
        open={openModalTransferir}
        handleClose={handleCloseModalTransferir}
        transferir={transferir}
        organismo={organismoTransferir}
      />
    </Paper>
  );
};

export default ListadoOrganismos;
